/**
 * Ordered index of documentation pages. This is the one hand-maintained list:
 * content is glob-loaded from ./content/*.md, so adding a page = drop a .md file
 * and add one line here. `slug` must match the markdown filename (without .md).
 */
export interface DocEntry {
  slug: string;
  title: string;
  group: string;
}

export const docsManifest: DocEntry[] = [
  { slug: 'index', title: 'Overview', group: 'Getting started' },

  { slug: 'instances-runners', title: 'Instances & Runners', group: 'Execution' },
  { slug: 'host-runner', title: 'Host Runner install', group: 'Execution' },
  { slug: 'operator-console', title: 'Operator Console', group: 'Execution' },
  { slug: 'relay-sessions', title: 'Relay Sessions', group: 'Execution' },

  { slug: 'projects', title: 'Projects', group: 'Organize' },
  { slug: 'tasks', title: 'Tasks', group: 'Organize' },
  { slug: 'agents', title: 'Agents', group: 'Organize' },
  { slug: 'teams', title: 'Teams', group: 'Organize' },
  { slug: 'presets', title: 'Presets', group: 'Organize' },

  { slug: 'mcp-tools', title: 'MCP Tools & Endpoints', group: 'Integrate' },
];

/** Preserve first-seen group order from the manifest. */
export function docGroups(): { group: string; entries: DocEntry[] }[] {
  const groups: { group: string; entries: DocEntry[] }[] = [];
  for (const entry of docsManifest) {
    let g = groups.find((x) => x.group === entry.group);
    if (!g) {
      g = { group: entry.group, entries: [] };
      groups.push(g);
    }
    g.entries.push(entry);
  }
  return groups;
}
